module.exports = __webpack_public_path__ + "img/Giving-Tuesday-logo-480w.1696b941.png";